// 直销商品搜索
<template>
    <div>
        <van-sticky>
            <van-nav-bar
                title="车品查找"
                left-text="返回"
                left-arrow
                @click-left="goback"/>
            <VipCarModel @pick="pickCarModel" />
            <van-tabs @click="tabclick">
                <van-tab :title="'综合' + (query.sortd==0? '↑': '↓')"></van-tab>
                <van-tab :title="'价格' + (query.sortd==0? '↑': '↓')"></van-tab>
                <van-tab :title="'销量' + (query.sortd==0? '↑': '↓')"></van-tab>
                <van-tab title="筛选"></van-tab>
            </van-tabs>
        </van-sticky>
        <van-list
            v-model="loading"
            :finished="finished"
            @load="onLoad">
            <ProdItem v-for="it in prods" :item="it" :key="it.id"/>
        </van-list>
    </div>
</template>

<script>
import { 
    NavBar, 
    Card, 
    Tabs, 
    Tab, 
    Icon, 
    Loading, 
    Toast, 
    List,
    Sticky
} from 'vant'
import { DirectSellApi } from '@/api/directsell'
import VipCarModel from '@/view/components/vipcarmodel'
import ProdItem from '@/view/directsell/components/proditem'
import { getCars, setCurrentCar } from '@/utils/localutils'

export default {
    name: 'ListItems',
    components: {
        [NavBar.name]: NavBar,
        [Card.name]: Card,
        [Tabs.name]: Tabs,
        [Tab.name]: Tab,
        [Icon.name]: Icon,
        [Loading.name]: Loading,
        [List.name]: List,
        [Sticky.name]: Sticky,
        VipCarModel,
        ProdItem
    },
    data() {
        return {
            prods: [],
            loading: false,
            finished: false,
            total: 0,
            query: {
                cls: null,
                cls1: null,
                prd_name: null,
                carmodel: null,
                purpose: null,
                sort: 0,
                sortd: 0,
                page: 1,
                page_size: 200
            },
            name: '分类商品',
        }
    },
    created() {
        if (this.$route.query) {
            try {
                const query = JSON.parse(this.$route.query)
                this.query = {
                    cls: query.cls,
                    cls1: query.cls1,
                    prd_name: query.prd_name,
                    // carmodel: query.carmodel,
                    purpose: query.purpose,
                    // page: 1,
                    // page_size: 10
                }
            } catch (ex) {
                console.log(ex)
            }
        }
        this.getData()
    },
    methods: {
        tabclick(sort) {
            if (sort == 3) {
                Toast('请等待...')
            } else {
                this.query.sort = sort
                this.query.sortd = (this.query.sortd == 0 ? 1 : 0)
                this.getData()
            }
        },
        getData() {
            var that = this
            that.loading = true
            const car = getCars()
            if (car != null && car.curCar !=null){
                if (car.curCar.carcategory_id !=null) {
                    that.query.carmodel = car.curCar.carcategory_id
                } else {
                    that.query.carmodel = car.curCar.series_id
                }
            }
            that.axios.get(DirectSellApi, { params: that.query}).then((ret) => {
                that.loading = false
                that.total = ret.count
                if (ret.results == null || ret.results.length ===0 ) {
                    that.prods = []
                    that.finished = true
                    return
                }
                // that.prods = Object.assign({}, that.prods, ret.results)
                that.prods = ret.results
                // that.data = that.data.concat(ret.results)
                if (that.prods.length >= that.total) {
                    that.finished = true
                }
            })
        },
        onLoad() {
            // this.query.page = this.query.page + 1
            // this.getData()
        },
        pickCarModel(item) {
            if (item.carcategory_id !=null) {
                this.query.carmodel = item.carcategory_id
            } else {
                this.query.carmodel = item.series_id
            }            
            setCurrentCar(item)
            this.getData()
        },
        goback() {
            try {
                this.$router.go(-1)
            } catch {
                this.$router.push(`/home`)
            }
        }
    }
}
</script>